export default {"src":"/_next/static/media/icon_11.3d5c502d.svg","height":34,"width":34};